import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 10000
});

// Add token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authAPI = {
  register: (username, email, password) =>
    apiClient.post('/auth/register', { username, email, password }),
  login: (email, password) =>
    apiClient.post('/auth/login', { email, password }),
  verify: () => apiClient.post('/auth/verify')
};

export const userAPI = {
  getMe: () => apiClient.get('/users/me'),
  getAllUsers: () => apiClient.get('/users'),
  getUser: (id) => apiClient.get(`/users/${id}`)
};

export const messageAPI = {
  getDirectMessages: (recipientId) =>
    apiClient.get(`/messages/direct/${recipientId}`),
  sendDirectMessage: (recipientId, content) =>
    apiClient.post('/messages/direct', { recipientId, content }),
  getGroupMessages: (groupId) =>
    apiClient.get(`/messages/group/${groupId}`),
  sendGroupMessage: (groupId, content) =>
    apiClient.post('/messages/group', { groupId, content })
};

export const fileAPI = {
  uploadFile: (file, messageId, groupMessageId) => {
    const formData = new FormData();
    formData.append('file', file);
    if (messageId) formData.append('messageId', messageId);
    if (groupMessageId) formData.append('groupMessageId', groupMessageId);
    return apiClient.post('/files/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  downloadFile: (filename) => `${API_URL}/files/download/${filename}`
};

export default apiClient;
